var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";
import { styleBlock } from "../styleBlock";
const SwitchNav = (_a) => {
    var { activeId, links, size, variant, className, ariaDescribedBy, legend } = _a, props = __rest(_a, ["activeId", "links", "size", "variant", "className", "ariaDescribedBy", "legend"]);
    const classNames = styleBlock("switchnav");
    const cn = classNames({}).mix([className]);
    return (React.createElement("fieldset", null,
        React.createElement("legend", { className: "sr-only" }, legend),
        React.createElement(ToggleButtonGroup, { type: "radio", name: "switchnav", className: cn.toString() }, links === null || links === void 0 ? void 0 : links.map(link => {
            var _a;
            return (React.createElement(ToggleButton, { id: (_a = link.id) === null || _a === void 0 ? void 0 : _a.toString(), value: link.id, variant: variant !== null && variant !== void 0 ? variant : "info", size: size, key: "switchnav-" + link.id, onClick: link.onClick, checked: link.id === activeId, className: link.id === activeId ? "active" : "" },
                React.createElement("a", { "aria-describedby": ariaDescribedBy, href: link.href }, link.title)));
        }))));
};
export default SwitchNav;
//# sourceMappingURL=index.js.map